import { RING_CRITICAL_PERCENT } from '../../../../constants';

export const TEST_ID = 'tabPanelComponents';

export const MOTOR_OVERTEMP_CELSIUS = 70;

export const K_FACTOR_DRIFT_THRESHOLD = 1.05;

export const WEAR_DUE_PERCENT = RING_CRITICAL_PERCENT;

export const K_FACTOR_PREFIX = 'K = ';

export const FLOW_RATE_SUFFIX = ' L/min';

export const RADAR_SELF_TEST = 'Self-test 2d ago';

export const PACK_VOLTAGE = '51.8V';

export const WEAR_UNCONFIGURED_VALUE = '—';
